module.exports = __webpack_public_path__ + "img/user.9bba3c87.svg";